export const advancedFiltersReducers = {
  /**
   * @template {keyof import("./advancedFiltersSlice").AdvancedFiltersState} T
   *
   * @param {import("./advancedFiltersSlice").AdvancedFiltersState} state
   * @param {{payload: {
   *    type: T;
   *    field: any;
   *    value: any;
   * }}} action
   */
  setFilterValue(state, action) {
    const { type, field, value } = action.payload;
    state[type][field] = value;
  },
};
